import React from "react";
import moment from 'moment';
import {component_tool, utils_tool} from "@/tool";
import { WizTableForm,WizClassifySelect } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, isNotAuth: true } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1, isNotAuth: true } })
let {WizModal} = component_tool;
let {$$, checkStrLength} = utils_tool;
//配置项
let componentName = 'examRecord';

let ref_;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const columns = (data) => {
  const {examId,className} = data;
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    
    {
      title: "题目内容",
      name: "title",
      tableItem: {
        width: 300,
      },
      searchItem: {}
    },
    {
      title: "题目编号",
      name: "number",
      tableItem: {
        width: 150,
      },
      searchItem: {}
    },
    {
      title: "所属分类",
      name: "categoryNames",
      tableItem: {
        width: 150,
      },
    },

    {
      title: "所属分类",
      name: "categoryIds",
      dataIndex: "categoryIds",
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {
          checkable: true,
          showSelectList: true,
          itemProps: {
            icon: 'unordered-list',
            title: '题目分类',
            tips: '请选择题目分类'
          },
          treeProps: {checkStrictly: true}
        },
        apiProps: {type: 2},
        selectProps: {
          placeholder: '请选择题目分类'
        },
      },
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "题目类型",
      name: "type",
      dataIndex: "type",
      tableItem: {
        width: 100,
      },
      dict: [
        { code: 0, codeName: "单选题" },
        { code: 1, codeName: "多选题" },
        { code: 2, codeName: "判断题" },
        { code: 3, codeName: "填空题" },
        { code: 4, codeName: "主观题" }
      ],
      searchItem: {
        type: "select"
      },
    },
    
    {
      title: "难度",
      name: "difficulty",
      dataIndex: "difficulty",
      tableItem: {
        width: 100,
      },
      dict: [
        { code: 0, codeName: "低" },
        { code: 1, codeName: "中" },
        { code: 2, codeName: "高" }
      ],
      searchItem: {
        type: "select"
      }
    },
    {
      title: "答题人数",
      name: "answerPersonIdCount",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "答题次数",
      name: "answerTimeCount",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "答错次数",
      name: "answerErrorTimeCount",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "错题率",
      name: "answerErrorRate",
      tableItem: {
      },
    },
    
  ]
};

const templateConfig = (data) => {
  const {examId,examName,examDate} = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(data),
        btnAccessCheck:false,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: ['export'],
          buttons: [
            
            {
              key: "export",
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters, examId: data.examId }
                }
              }
            },
          ]
        },
       
        dataTableProps: {
          rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['errorQuestionAnalysis'],
        rowOperateView: [
          {
            key: 'errorQuestionAnalysis',//错题率详情
            custom: true,
            params: {children: '错题分析'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/online/examRecord/errorQuestionInfo/errorQuestionAnalysis',
                record: data
              }
            }
          },
        ],
        commonOperate: {
          add: true,
          delete: false,
          look: true
        }
      }
    }
  };
};

const apis = (data) => {
  const {examId} = data;
  return {
    list: {
      path: `${componentName}/getErrorQuetionPage`,
      payload: {
        key: `${componentName}@getErrorQuetionPage`,
        apiParams: {pageNum: 1, pageSize: 10,examId}
      }
    },
    export: {
      path: `${componentName}/getErrorQuetionExport`,
      payload: {
        key: `${componentName}@getErrorQuetionExport`,
        apiParams: {examId}
      }
    },
  }
};


let reduxTemplateConfig = (args) => {
  const {examId} = args;
  return {
    apis: apis({examId}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
